import React from 'react'
import { Element } from 'react-scroll'
import './About.scss'

const About = () => (
  <>
    <div
      className="fixed-banner about-the-band"
      role="img"
      aria-label="band music rock opera rope and ladder"
    />
    <Element className="page-section dark-section" id="about" name="about">
      <div className="about">
        <div className="about-wrapper">
          <div className="section-header">About the Band</div>
          <p>
            Rope and Ladder is the musical partnership of Jay Clark and Ryan Dolen. They write gritty, melodic music. Sometimes cinematic, sometimes loud.
          </p>
          <p>
            Their 2020 rock opera, “Rope and Ladder,” covered expansive theatrical motifs - war, love, betrayal.
          </p>
          <p>
            Their new record, “This is Wild,” turns inward - a meditation on loss and the vast ache that we accumulate. The album explores the subject from all directions and dynamics - offseting moments of whispered stillnes with shattering peaks, pulling the listener relentlessly from beginning to end.
          </p>
        </div>
      </div>
    </Element>
  </>
)

export default About
